import { render } from "./architectureSecondScreen.vue?vue&type=template&id=c8bee9a0"
import script from "./architectureSecondScreen.vue?vue&type=script&lang=js"
export * from "./architectureSecondScreen.vue?vue&type=script&lang=js"

import "./architectureSecondScreen.vue?vue&type=style&index=0&id=c8bee9a0&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__